import { Alert, Box, Button } from '@mui/material';

const SAVE_BUTTON_SX = { color: 'common.white' };

const OAuthCredentialActions = ({
  providerName,
  testResult,
  saving,
  testing,
  readOnly,
  hasCredential,
  canTest,
  onSave,
  onTest,
}) => (
  <>
    {testResult?.authenticated && (
      <Alert severity='success' sx={{ mt: 2 }}>
        {providerName} authentication succeeded.
      </Alert>
    )}
    {testResult && !testResult.authenticated && (
      <Alert severity='error' sx={{ mt: 2 }}>
        {providerName} authentication failed: {testResult.failure_reason}
      </Alert>
    )}

    <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
      <Button
        variant='contained'
        color='primary'
        onClick={onSave}
        disabled={saving || testing || readOnly}
        sx={SAVE_BUTTON_SX}>
        {saving && 'Saving...'}
        {!saving && 'Save Credentials'}
      </Button>
      {canTest && (
        <Button
          variant='outlined'
          color='primary'
          onClick={onTest}
          disabled={saving || testing || readOnly || !hasCredential}>
          {testing && 'Testing...'}
          {!testing && 'Test Authentication'}
        </Button>
      )}
    </Box>
  </>
);

export default OAuthCredentialActions;
